<template>
  <div class="gpicker">
    <input type="text" v-model="value" class="vinput" v-if="isInput" :placeholder="placeholder">
    <div type="text" class="ginput" @click="open" v-else>
      <template v-if="disValue">
        <template v-if="isHtml"><span v-html="disValue" class="bil"></span></template>
        <template v-else>{{disValue}}</template>
      </template>
      <span v-else class="ph">{{placeholder}}</span>
    </div>
    <i class="iconfont icon-xia" @click="open"></i>
    <vue-pickers :show="show" :isHtml="isHtml" :selectData="optionSlot" v-on:cancel="close"
                 v-on:confirm="confirmFn"></vue-pickers>
  </div>
</template>

<script>
  import VuePickers from "../common/selectPicker";

  export default {
    data() {
      return {
        show: false,
        disValue: "",
        value: "",
        optionSlot: {
          columns: 1,
          default: [{
            text: "",
            value: ""
          }],
          pData1: []
        },
        data: [],
        disFormat: null
      };
    },
    props: {
      placeholder: {
        type: String
      },
      isInput: {
        type: Boolean,
        default: false
      },
      isHtml: {
        type: Boolean,
        default: false
      },
      canEmpty: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
    },
    methods: {
      setData(datas, dv, df) {
        if (this.canEmpty) {
          datas.unshift({
            code: null,
            e: "",
            name: "空",
          })
        }

        this.data = datas;
        this.value = dv;
        if (df != null) {
          this.disFormat = df;
        }
        this.setInit();
        this.show = false;
      },
      setInit() {
        this.optionSlot.pData1 = [];
        let bfind = this.value == null
        if (this.data != null) {
          this.data.forEach((val, key, arr) => {
            var text =
              this.disFormat == null ? arr[key].name : this.disFormat(arr[key]);
            this.optionSlot.pData1.push({
              text: text,
              value: arr[key].code
            });
            if (!bfind && this.value == arr[key].code) {
              this.disValue = text;
              bfind = true;
            }
          });

          if (!bfind && this.optionSlot.pData1.length > 0) {
            this.disValue = this.optionSlot.pData1[0].text;
            this.value = this.optionSlot.pData1[0].value;
          }
          this.optionSlot.default = [{
            text: this.disValue,
            value: this.value
          }];
          //  console.log(this.optionSlot);
        }
      },
      setDefault(v) {
        if (v) {
          this.value = v;
          this.setInit();
        } else {
          this.clear();
        }
        this.$emit("change", this.value, this.disValue);
      },
      clear() {
        this.value = null;
        this.disValue = null;
      },
      open() {
        this.show = !this.show;
        if (this.show) {
          this.setInit();
        }
      },
      close() {
        this.show = false;
      },
      getValue() {
        return this.value;
      },
      getDisValue() {
        return this.disValue;
      },
      getDisValueF() {
        return this.getNameFromDis(this.disValue);
      },
      getNameFromDis(v) {
        if (v) {
          return v.split(' -- ')[1];
        }
        return "";
      },
      confirmFn(data) {
        let select1 = data.select1 || {}
        this.show = false;
        this.disValue = select1.text;
        this.value = select1.value;

        if(this.canEmpty && (this.value == null)){
          this.disValue = ''
        }

        this.$emit("change", this.value, this.disValue);
      }
    },
    filters: {},
    watch: {},
    components: {
      VuePickers
    }
  };
</script>

<style lang="less">
  .gpicker {
    height: 0.8rem;
    line-height: 0.8rem;

    .ginput {
      width: 100%;
      height: 100%;
      padding-right: 0.5rem;
      overflow: hidden;
      box-sizing: border-box;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .icon-xia {
      position: absolute;
      right: 0.08rem;
      top: 0px;
    }

    .ph {
      color: #ccc;
    }

    .bil {
      span {
        display: inline-block;
        width: 3rem;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// gpicker.vue?3cead81c